import { DGEImportLicensesPreviewResponse } from '@img-arena/consoles-api-streaming'
import { territories } from '@/components/forms/GeoBlockingTemplateForm'

export const transformDataForApprove = (
  data: DGEImportLicensesPreviewResponse,
  selectedLicenses: Set<number>,
  selectedProperties: Map<number, number>,
  selectedPropertyNames: Map<number, string>
) => {
  if (!data.licenses) return { licenses: [] }

  const selectedLicensesData = data.licenses.filter((_, index) => selectedLicenses.has(index))

  return {
    licenses: selectedLicensesData.map((license, index) => {
      const countryNames =
        license?.geoList?.countryCodes
          ?.map((code: string) => {
            const territory = territories.find((t) => t.iso2 === code)
            return territory?.name || code
          })
          .filter(Boolean) || []

      const selectedPropertyId = selectedProperties.get(index)
      const propertyId = selectedPropertyId || license?.property?.id || 0
      const selectedPropertyName = selectedPropertyNames.get(index)
      const propertyName = selectedPropertyName || license?.property?.name || ''

      return {
        property: {
          id: propertyId,
          name: propertyName
        },
        geoList: {
          countryCodes: license?.geoList?.countryCodes || [],
          isWhitelist: license?.geoList?.isWhitelist || false
        },
        isAutomaticBooking: license?.isAutomaticBooking || false,
        licenseDates:
          license?.licenseDates?.map((period) => {
            const isAutoBooking = license?.isAutomaticBooking || false

            if (isAutoBooking) {
              return {
                startDate: new Date(period.startDate).toISOString(),
                endDate: new Date(period.endDate).toISOString()
              }
            } else {
              return {
                startDate: new Date(period.startDate).toISOString(),
                endDate: new Date(period.endDate).toISOString(),
                maxEvents: period.maxEvents ?? 0,
                purchasedEvents: period.purchasedEvents ?? 0
              }
            }
          }) || [],
        selected: true,
        latestEndDateMoment:
          license?.licenseDates
            ?.map((period) => new Date(period.endDate))
            ?.sort((a, b) => b.getTime() - a.getTime())[0]
            ?.toISOString() || new Date().toISOString(),
        latestEndDate:
          license?.licenseDates
            ?.map((period) => new Date(period.endDate))
            ?.sort((a, b) => b.getTime() - a.getTime())[0]
            ?.toLocaleDateString('en-GB') || new Date().toLocaleDateString('en-GB'),
        date: {},
        countryWhitelist: countryNames,
        datePickerOptions: {
          singleDatePicker: true,
          locale: {
            format: 'DD/MM/YYYY'
          },
          drops: 'down',
          opens: 'center',
          showDropdowns: true,
          eventHandlers: {}
        }
      }
    })
  }
}
